// extracted by mini-css-extract-plugin
export default {"smallButton":"SmallButton_smallButton__NsulO"};